import { Grid, Box, Typography, Button, Container, Paper, FormControlLabel, Checkbox } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useEffect, useContext, useState } from 'react';
import LogicContext from '../../Context/LogicContext';
import { createModal } from 'react-modal-promise';
import GeneralModal from '../../helpers/GeneralModal';
import SelectSelect from './StatusSelect';
import { FileUploader } from 'react-drag-drop-files';
import { settingsService } from '../../services/settingsService';
import { GetEditFeatureAtom, SetEditFeatureAtom } from '../../store/settingsAtom';
import moment from 'moment';
import { GetSettingsListAtom, SetSettingsListAtom } from '../../store/settingsAtom';
import { FEATURE_WIDTH, FEATURE_HEIGHT } from '../../helpers/constantsFile';
import FeatureSelect from './FeatureSelect';
import VisibleToggle from './VisibleToggle';
import { toLowercaseKeys } from '../../helpers/toLowerCaseKeys';
import imageCompression from 'browser-image-compression';

function AddHomePageFeature() {
  const navigate = useNavigate();
  const myPromiseModal = createModal(GeneralModal);
  const dataList = GetSettingsListAtom();
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();
  const logicContext = useContext(LogicContext);
  const [infinityCheck, setInfinityCheck] = useState(false);
  const [mobileUrl, setMobileUrl] = useState('');
  const [webUrl, setWebUrl] = useState('');
  const setEditFeature = SetEditFeatureAtom();
  const getEditFeature = GetEditFeatureAtom();
  const [file, setFile] = useState(null);
  const [imageSource, setImageSource] = useState(null);
  const fileTypes = ['JPG', 'PNG', 'GIF', 'JPEG'];

  useEffect(() => {
    setValue('feature_status_id', 1);
    setValue('app_visible_id', 1);
    setValue('web_visible_id', 1);

    if (getEditFeature?.Ref_No) {
      setValue('feature_status_id', getEditFeature.Feature_Status_Id);
      setValue('feature_name', getEditFeature.Feature_Name);
      setValue('feature_action_url_id', getEditFeature.Feature_Action_URL_Id);
      setMobileUrl(getEditFeature?.Feature_Action_URL_Mobile);
      setWebUrl(getEditFeature?.Feature_Action_URL_Web);
      setValue('slide_order', getEditFeature.Slide_Order);
      setValue('feature_image_url', getEditFeature.Feature_Image_URL);
      setValue('app_visible_id', getEditFeature.App_Visible_Id);
      setValue('web_visible_id', getEditFeature.Web_Visible_Id);
      setImageSource(getEditFeature.Feature_Image_URL);
    }

    return () => {
      setEditFeature({});
    };
  }, [getEditFeature?.Ref_No]);

  const onMobileVisible = val => {
    setValue('app_visible_id', val);
  };

  const onWebVisible = val => {
    setValue('web_visible_id', val);
  };

  const changeHandler = event => {
    setInfinityCheck(prev => !prev);
  };

  const onStatusSelect = eveData => {
    setValue('feature_status_id', eveData.value);
  };

  const onImageLoad = event => {
    const imageWidth = event?.target?.naturalWidth;
    const imageHeight = event?.target?.naturalHeight;
  };

  const handleImageChange = async imageFile => {
    if (!imageFile) return;

    let imageUrl = null;

    try {
      const img = new Image();
      imageUrl = URL.createObjectURL(imageFile);

      img.onload = async () => {
        try {
          // Check only width (must be FEATURE_WIDTH)
          // if (img.width !== FEATURE_WIDTH) {
          //   logicContext.showToast(`Invalid image width! Required: ${FEATURE_WIDTH}px, Got: ${img.width}px`, 'error');
          //   return;
          // }

          // Compress the image
          const originalSizeMB = imageFile.size / 1024 / 1024;

          const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: FEATURE_WIDTH,
            useWebWorker: true,
            fileType: 'image/jpeg',
          };

          logicContext.showToast('Image compressing...', 'info');
          const compressedFile = await imageCompression(imageFile, options);
          setFile(compressedFile);

          const reader = new FileReader();
          reader.addEventListener('load', () => {
            setImageSource(reader.result);
          });
          reader.readAsDataURL(compressedFile);

          const compressedSizeMB = compressedFile.size / 1024 / 1024;
          logicContext.showToast(`Image optimized: ${originalSizeMB.toFixed(2)}MB → ${compressedSizeMB.toFixed(2)}MB`, 'success');
        } finally {
          URL.revokeObjectURL(imageUrl);
        }
      };

      img.onerror = () => {
        URL.revokeObjectURL(imageUrl);
        logicContext.showToast('Failed to load image', 'error');
      };

      img.src = imageUrl;
    } catch (error) {
      // Clean up blob URL if error occurs
      if (imageUrl) {
        URL.revokeObjectURL(imageUrl);
      }
      logicContext.showToast('Failed to process image', 'error');
      console.error('Compression error:', error);
    }
  };

  const clearImage = () => {
    setFile(null);
    setImageSource(null);
    // Trigger a change event to clear the file input if needed
    const uploader = document.getElementById('uploader');
    if (uploader) {
      uploader.value = '';
    }
  };

  const onFeatureSelect = data => {
    setValue('feature_action_url_id', data?.Feature_Action_URL_Id);
    setWebUrl(data?.Feature_Action_URL_Web);
    setMobileUrl(data?.Feature_Action_URL_Mobile);
  };

  const onSubmit = async formValues => {
    if (!imageSource) {
      return logicContext.showToast('Please upload feature image', 'error');
    }

    // Start edit
    if (getEditFeature?.Ref_No) {
      await myPromiseModal({
        title: 'Update record!',
        body: `Please confirm your action.`,
        showInput: false,
        placeHolder: '',
      }).then(res => {
        if (res.decision === true) {
          const formData = new FormData();
          if (infinityCheck) {
            delete formValues?.end_date;
          }

          formData.append('file', file);
          var formObject = JSON.stringify({ ...formValues, ref_no: getEditFeature?.Ref_No });
          formData.append('formObject', formObject);
          settingsService.updateFeature(formData).then(res => {
            const cleanResponse = logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);
            const { message_id, message_text } = cleanResponse;
            if (message_id == 1) {
              logicContext.showToast(message_text, 'success');
              navigate(-1);
              sessionStorage.setItem('reloadPage', 'true');
            }
          });
        }
      });
    } else {
      // New record
      await myPromiseModal({
        title: 'Save record!',
        body: `Please confirm your action.`,
        showInput: false,
        placeHolder: '',
      }).then(res => {
        if (res.decision === true) {
          const formData = new FormData();
          if (infinityCheck) {
            delete formValues?.end_date;
          }
          formData.append('file', file);
          var formObject = JSON.stringify(formValues);
          formData.append('formObject', formObject);
          settingsService.submitNewFeature(formData).then(res => {
            const serverRes = toLowercaseKeys(res.data);
            const cleanResponse = logicContext.httpResponseManager(serverRes?.[0] || serverRes?.result_status?.[0]);
            const { message_id, message_text } = cleanResponse;
            if (message_id == 1) {
              logicContext.showToast(message_text, 'success');
              reset();
            }
          });
        }
      });
    }
  };

  function formError(error) {
    logicContext.showToast('Form error', 'error');
  }

  const defaultStartDate = getEditFeature?.Start_Date
    ? moment(getEditFeature.Start_Date).format('YYYY-MM-DD')
    : moment(Date.now()).format('YYYY-MM-DD');

  const defaultEndDate = getEditFeature?.End_Date
    ? moment(getEditFeature.End_Date).format('YYYY-MM-DD')
    : moment(Date.now()).format('YYYY-MM-DD');

  return (
    <Container maxWidth="md">
      <Paper elevation={3} sx={{ p: 4, mt: 2, mb: 2 }}>
        <Typography variant="h5" component="h1" gutterBottom align="center" color="primary">
          {getEditFeature?.Ref_No ? 'Edit' : 'Add New'} Home Page Feature
        </Typography>

        <form onSubmit={handleSubmit(onSubmit, formError)}>
          <Grid container spacing={3}>
            {/* Row 1: Feature Name & Image Upload */}
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                Feature Name
              </Typography>
              <input
                className="bg-inputColor h-[6vh] pl-3 w-full"
                placeholder="Enter feature name"
                type="text"
                {...register('feature_name', {
                  required: 'Feature name is required',
                })}
              />
              {errors.feature_name && (
                <Typography variant="caption" color="error" display="block">
                  {errors.feature_name.message}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                Feature Image
              </Typography>
              <div className="flex flex-col items-center space-y-4 p-4 border border-gray-200 rounded-lg bg-white shadow-sm">
                {/* Upload Area */}
                <div className="w-full max-w-sm">
                  <FileUploader
                    className="uploader border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-blue-400 transition-colors cursor-pointer bg-gray-50"
                    id="uploader"
                    minSize={0.1}
                    maxSize={3}
                    handleChange={handleImageChange}
                    name="file"
                    types={fileTypes}
                    multiple={false}
                  >
                    <div className="flex flex-col items-center space-y-2">
                      <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                      </svg>
                      <p className="text-sm font-medium text-gray-700">Drop your image here or click to browse</p>
                      <p className="text-xs text-gray-500">Supports JPG, PNG (max 3MB)</p>
                    </div>
                  </FileUploader>
                </div>

                {/* Preview */}
                {imageSource ? (
                  <div className="flex justify-center">
                    <div className="relative">
                      <img
                        className="rounded-full border-4 border-gray-200 shadow-lg object-cover"
                        onLoad={e => onImageLoad(e)}
                        src={imageSource}
                        alt="Preview"
                        style={{ width: '200px', height: '200px' }}
                      />
                      <button
                        className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-600 transition-colors"
                        onClick={clearImage}
                        type="button"
                      >
                        ×
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="w-48 h-48 rounded-full bg-gray-100 flex items-center justify-center border-2 border-dashed border-gray-300">
                    <p className="text-gray-500 text-sm">No image selected</p>
                  </div>
                )}
              </div>
            </Grid>

            {/* Row 2: Feature Select */}
            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                Feature Action
              </Typography>
              <FeatureSelect onFeatureSelect={onFeatureSelect} defaultVal={getEditFeature?.Feature_Name} list={dataList.action_url_info} />
              <Box mt={2} sx={{ display: 'flex', flexDirection: 'column', gap: 1, fontWeight: 'bold' }}>
                <Box>
                  Mobile URL: <span className="text-primary">{mobileUrl}</span>
                  <VisibleToggle visible={getEditFeature?.Web_Visible_Id} onVisibleChange={onMobileVisible} />
                </Box>
                <Box>
                  Web URL: <span className="text-primary">{webUrl}</span>
                  <VisibleToggle visible={getEditFeature?.App_Visible_Id} onVisibleChange={onWebVisible} />
                </Box>
              </Box>
            </Grid>

            {/* Row 3: Dates */}
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                Start Date
              </Typography>
              <input
                className="bg-inputColor h-[6vh] pl-3 w-full"
                type="date"
                {...register('start_date', {
                  required: 'Start date is required',
                })}
                defaultValue={defaultStartDate}
              />
              {errors.start_date && (
                <Typography variant="caption" color="error" display="block">
                  {errors.start_date.message}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                End Date
              </Typography>
              <input
                className="bg-inputColor h-[6vh] pl-3 w-full"
                type="date"
                {...register('end_date', {
                  required: !infinityCheck && 'End date is required',
                })}
                defaultValue={defaultEndDate}
              />
              {errors.end_date && (
                <Typography variant="caption" color="error" display="block">
                  {errors.end_date.message}
                </Typography>
              )}
              <FormControlLabel
                control={<Checkbox checked={infinityCheck} onChange={changeHandler} name="unlimited" />}
                label="Unlimited Duration"
                sx={{ mt: 1 }}
              />
            </Grid>

            {/* Row 4: Slide Order & Status */}
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                Slide Order
              </Typography>
              <input
                className="bg-inputColor h-[6vh] pl-3 w-full"
                placeholder="Enter slide order"
                type="number"
                {...register('slide_order', {
                  required: 'Slide order is required',
                })}
              />
              {errors.slide_order && (
                <Typography variant="caption" color="error" display="block">
                  {errors.slide_order.message}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                Status
              </Typography>
              <SelectSelect defaultVal={getEditFeature?.Feature_Status_Id} onStatusSelect={onStatusSelect} />
            </Grid>
          </Grid>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
            <Button type="submit" variant="contained" size="large" sx={{ px: 4, py: 1.5 }}>
              Submit
            </Button>
          </Box>
        </form>
      </Paper>
    </Container>
  );
}

export default AddHomePageFeature;
